import {
  ILeadsOverviewBillboardConfig,
  ILeadsOverviewConfig,
  ILeadsOverviewDealerKpiConfig,
  IDefaultTableColumnConfig,
  ILeadsOverviewKpiConfig,
  ILeadsOverviewSourceTypeCardConfig,
  IPropertyOverride
} from '../../../../_shared/models/models-index';

import * as constants from '../../../../_shared/constants/constants';
export class LeadsOverviewConfig implements ILeadsOverviewConfig {
  public reportTitle = 'Leads Overview';
  metricDisplayModes = [
    {name: 'MOM', value: 'MOM'},
    {name: 'YOY', value: 'YOY'},
  ];
  public useDefaultComparisonColumns = true;
  public dealerLevelMetricOverrides: IPropertyOverride[] = [
    {
      baseProperty: 'bestMatchCloseRate',
      overrideProperty: 'sameDealerBestMatchCloseRate'
    },
    {
      baseProperty: 'bestMatchCloseRate30',
      overrideProperty: 'sameDealerBestMatchCloseRate30'
    },
    {
      baseProperty: 'bestMatchCloseRate60',
      overrideProperty: 'sameDealerBestMatchCloseRate60'
    },
    {
      baseProperty: 'bestMatchCloseRate90',
      overrideProperty: 'sameDealerBestMatchCloseRate90'
    },
  ];
  public sourceTypeCardConfig: ILeadsOverviewSourceTypeCardConfig = {
    showComparisonMetrics: true,
    leadMetric: {
      name: 'Unique Leads',
      value: 'uniqueLeads'
    },
    closeRateMetric: {
      name: 'Close Rate',
      value: 'bestMatchCloseRate'
    }
  }

  lookbackMonths = 3;
  public billboards: ILeadsOverviewBillboardConfig[] = [
    {
      title: 'Lead Volume',
      subtitle: '',
      iconClass: 'fa-user fa-primary',
      reverseMetric: false,
      metricCurrentPropertyName: 'leadVolume',
      metricMOMPropertyName: 'leadVolumeMOM',
      metricYOYPropertyName: 'leadVolumeYOY',
      metricPreviousMonthPropertyName: 'leadVolumePreviousMonth',
      metricPreviousMTDPropertyName: 'leadVolumePreviousMTD',
      metricPreviousYearPropertyName: 'leadVolumePreviousYear',
      metricPreviousMTDDisplayOnCurrentMonth: true,
      metricPreviousMTDDisplayHistorical: false,
      metricPreviousMTDLabel: 'Prev. MTD',
      metricPreviousMonthDisplayOnCurrentMonth: true,
      metricPreviousMonthDisplayHistorical: true,
      metricPreviousMonthLabel: 'Prev. Month',
      footerRowCount: 1,
      footerTwoLeftLabel: 'MOM',
      footerTwoRightLabel: 'YOY',
      footerTwoMetricFormatKey: constants.formatKeys.percentageOneDecimal,
      trendArrowDrivingPropertyName: 'leadVolumeMOM',
      metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
      helpTextKey: 'LeadsOverviewLeadVolumeBillboardHelp',
      helpTextTitle: 'Lead Volume',
      showTrendArrow: true
    },
    {
      title: 'Responded < 15 Min',
      subtitle: '',
      iconClass: 'fa-percent fa-primary',
      reverseMetric: false,
      metricCurrentPropertyName: 'responseRate15',
      metricMOMPropertyName: 'responseRate15MOM',
      metricYOYPropertyName: 'responseRate15YOY',
      metricPreviousMonthPropertyName: 'responseRate15PreviousMonth',
      metricPreviousMTDPropertyName: 'responseRate15PreviousMTD',
      metricPreviousYearPropertyName: 'responseRate15PreviousYear',
      metricPreviousMTDDisplayOnCurrentMonth: true,
      metricPreviousMTDDisplayHistorical: false,
      metricPreviousMTDLabel: 'Prev. MTD',
      metricPreviousMonthDisplayOnCurrentMonth: true,
      metricPreviousMonthDisplayHistorical: true,
      metricPreviousMonthLabel: 'Prev. Month',
      footerRowCount: 1,
      footerTwoLeftLabel: 'MOM',
      footerTwoRightLabel: 'YOY',
      footerTwoMetricFormatKey: constants.formatKeys.percentageOneDecimal,
      trendArrowDrivingPropertyName: 'responseRate15MOM',
      metricFormatKey: constants.formatKeys.percentageOneDecimal,
      helpTextKey: 'LeadsOverviewResponded15BillboardHelp',
      helpTextTitle: 'Responded Less Than 15 min',
      showTrendArrow: true
    },
    {
      title: 'Appointment Rate',
      subtitle: '',
      iconClass: 'fa-calendar fa-primary',
      reverseMetric: false,
      metricCurrentPropertyName: 'appointmentRate',
      metricMOMPropertyName: 'appointmentRateMOM',
      metricYOYPropertyName: 'appointmentRateYOY',
      metricPreviousMonthPropertyName: 'appointmentRatePreviousMonth',
      metricPreviousMTDPropertyName: 'appointmentRatePreviousMTD',
      metricPreviousYearPropertyName: 'appointmentRatePreviousYear',
      metricPreviousMTDDisplayOnCurrentMonth: true,
      metricPreviousMTDDisplayHistorical: false,
      metricPreviousMTDLabel: 'Prev. MTD',
      metricPreviousMonthDisplayOnCurrentMonth: true,
      metricPreviousMonthDisplayHistorical: true,
      metricPreviousMonthLabel: 'Prev. Month',
      footerRowCount: 1,
      footerTwoLeftLabel: 'MOM',
      footerTwoRightLabel: 'YOY',
      footerTwoMetricFormatKey: constants.formatKeys.percentageOneDecimal,
      trendArrowDrivingPropertyName: 'appointmentRateMOM',
      metricFormatKey: constants.formatKeys.percentageOneDecimal,
      helpTextKey: 'LeadsOverviewAppointmentRateBillboardHelp',
      helpTextTitle: 'Appointment Rate',
      showTrendArrow: true
    },
    {
      title: 'Close Rate',
      subtitle: '',
      iconClass: 'fa-percent fa-primary',
      reverseMetric: false,
      metricCurrentPropertyName: 'bestMatchCloseRate60',
      metricMOMPropertyName: 'bestMatchCloseRate60MOM',
      metricYOYPropertyName: 'bestMatchCloseRate60YOY',
      metricPreviousMonthPropertyName: 'bestMatchCloseRate60PreviousMonth',
      metricPreviousMTDPropertyName: 'bestMatchCloseRate60PreviousMTD',
      metricPreviousYearPropertyName: 'bestMatchCloseRate60PreviousYear',
      metricPreviousMTDDisplayOnCurrentMonth: true,
      metricPreviousMTDDisplayHistorical: false,
      metricPreviousMTDLabel: 'Prev. MTD',
      metricPreviousMonthDisplayOnCurrentMonth: true,
      metricPreviousMonthDisplayHistorical: true,
      metricPreviousMonthLabel: 'Prev. Month',
      footerRowCount: 1,
      footerTwoLeftLabel: 'MOM',
      footerTwoRightLabel: 'YOY',
      footerTwoMetricFormatKey: constants.formatKeys.percentageOneDecimal,
      trendArrowDrivingPropertyName: 'bestMatchCloseRate60MOM',
      metricFormatKey: constants.formatKeys.percentageOneDecimal,
      helpTextKey: 'LeadsOverviewCloseRateBillboardHelp',
      helpTextTitle: 'Close Rate',
      showTrendArrow: true
    }
  ];

  public dealerbillboards: ILeadsOverviewBillboardConfig[] = [
    {
      title: 'Lead Volume',
      subtitle: '',
      iconClass: 'fa-user fa-primary',
      reverseMetric: false,
      metricCurrentPropertyName: 'leadVolume',
      metricMOMPropertyName: 'leadVolumeMOM',
      metricYOYPropertyName: 'leadVolumeYOY',
      metricPreviousMonthPropertyName: 'leadVolumePreviousMonth',
      metricPreviousMTDPropertyName: 'leadVolumePreviousMTD',
      metricPreviousYearPropertyName: 'leadVolumePreviousYear',
      metricPreviousMTDDisplayOnCurrentMonth: true,
      metricPreviousMTDDisplayHistorical: false,
      metricPreviousMTDLabel: 'Prev. MTD',
      metricPreviousMonthDisplayOnCurrentMonth: true,
      metricPreviousMonthDisplayHistorical: true,
      metricPreviousMonthLabel: 'Prev. Month',
      footerRowCount: 1,
      footerTwoLeftLabel: 'MOM',
      footerTwoRightLabel: 'YOY',
      footerTwoMetricFormatKey: constants.formatKeys.percentageOneDecimal,
      trendArrowDrivingPropertyName: 'leadVolumeMOM',
      metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
      helpTextKey: 'LeadsOverviewLeadVolumeBillboardHelp',
      helpTextTitle: 'Lead Volume',
      showTrendArrow: true
    },
    {
      title: 'Responded < 15 Min',
      subtitle: '',
      iconClass: 'fa-percent fa-primary',
      reverseMetric: false,
      metricCurrentPropertyName: 'responseRate15',
      metricMOMPropertyName: 'responseRate15MOM',
      metricYOYPropertyName: 'responseRate15YOY',
      metricPreviousMonthPropertyName: 'responseRate15PreviousMonth',
      metricPreviousMTDPropertyName: 'responseRate15PreviousMTD',
      metricPreviousYearPropertyName: 'responseRate15PreviousYear',
      metricPreviousMTDDisplayOnCurrentMonth: true,
      metricPreviousMTDDisplayHistorical: false,
      metricPreviousMTDLabel: 'Prev. MTD',
      metricPreviousMonthDisplayOnCurrentMonth: true,
      metricPreviousMonthDisplayHistorical: true,
      metricPreviousMonthLabel: 'Prev. Month',
      footerRowCount: 1,
      footerTwoLeftLabel: 'MOM',
      footerTwoRightLabel: 'YOY',
      footerTwoMetricFormatKey: constants.formatKeys.percentageOneDecimal,
      trendArrowDrivingPropertyName: 'responseRate15MOM',
      metricFormatKey: constants.formatKeys.percentageOneDecimal,
      helpTextKey: 'LeadsOverviewResponded15BillboardHelp',
      helpTextTitle: 'Responded Less Than 15 min',
      showTrendArrow: true
    },
    {
      title: 'Appointment Rate',
      subtitle: '',
      iconClass: 'fa-calendar fa-primary',
      reverseMetric: false,
      metricCurrentPropertyName: 'appointmentRate',
      metricMOMPropertyName: 'appointmentRateMOM',
      metricYOYPropertyName: 'appointmentRateYOY',
      metricPreviousMonthPropertyName: 'appointmentRatePreviousMonth',
      metricPreviousMTDPropertyName: 'appointmentRatePreviousMTD',
      metricPreviousYearPropertyName: 'appointmentRatePreviousYear',
      metricPreviousMTDDisplayOnCurrentMonth: true,
      metricPreviousMTDDisplayHistorical: false,
      metricPreviousMTDLabel: 'Prev. MTD',
      metricPreviousMonthDisplayOnCurrentMonth: true,
      metricPreviousMonthDisplayHistorical: true,
      metricPreviousMonthLabel: 'Prev. Month',
      footerRowCount: 1,
      footerTwoLeftLabel: 'MOM',
      footerTwoRightLabel: 'YOY',
      footerTwoMetricFormatKey: constants.formatKeys.percentageOneDecimal,
      trendArrowDrivingPropertyName: 'appointmentRateMOM',
      metricFormatKey: constants.formatKeys.percentageOneDecimal,
      helpTextKey: 'LeadsOverviewAppointmentRateBillboardHelp',
      helpTextTitle: 'Appointment Rate',
      showTrendArrow: true
    },
    {
      title: 'Close Rate',
      subtitle: '',
      iconClass: 'fa-percent fa-primary',
      reverseMetric: false,
      metricCurrentPropertyName: 'sameDealerBestMatchCloseRate60',
      metricMOMPropertyName: 'sameDealerBestMatchCloseRate60MOM',
      metricYOYPropertyName: 'sameDealerBestMatchCloseRate60YOY',
      metricPreviousMonthPropertyName: 'sameDealerBestMatchCloseRate60PreviousMonth',
      metricPreviousMTDPropertyName: 'sameDealerBestMatchCloseRate60PreviousMTD',
      metricPreviousYearPropertyName: 'sameDealerBestMatchCloseRate60PreviousYear',
      metricPreviousMTDDisplayOnCurrentMonth: true,
      metricPreviousMTDDisplayHistorical: false,
      metricPreviousMTDLabel: 'Prev. MTD',
      metricPreviousMonthDisplayOnCurrentMonth: true,
      metricPreviousMonthDisplayHistorical: true,
      metricPreviousMonthLabel: 'Prev. Month',
      footerRowCount: 1,
      footerTwoLeftLabel: 'MOM',
      footerTwoRightLabel: 'YOY',
      footerTwoMetricFormatKey: constants.formatKeys.percentageOneDecimal,
      trendArrowDrivingPropertyName: 'sameDealerBestMatchCloseRate60MOM',
      metricFormatKey: constants.formatKeys.percentageOneDecimal,
      helpTextKey: 'LeadsOverviewCloseRateBillboardHelp',
      helpTextTitle: 'Close Rate',
      showTrendArrow: true
    }
  ];

  public dealerKpiCardConfig: ILeadsOverviewDealerKpiConfig = {
    metrics: {
      'CloseRate': {
        yAxisTitle: 'Close Rate %',
        displayName: 'Close Rate %',
        pointLabelFormat: null,
        propertyName: 'sameDealerBestMatchCloseRate',
        metricFormatKey: null,
        formatter: null
      },
      'LeadVolume': {
        yAxisTitle: 'Lead Volume',
        displayName: 'Lead Volume',
        pointLabelFormat: null,
        propertyName: 'leadVolume',
        metricFormatKey: null,
        formatter: null
      },
      'ResponseRate': {
        yAxisTitle: 'Responded < 15 Min',
        displayName: 'Responded < 15 Min',
        pointLabelFormat: null,
        propertyName: 'responseRate15',
        metricFormatKey: null,
        formatter: null
      }
    }
  };

  public kpiCardConfig: ILeadsOverviewKpiConfig = {
    metrics: {
      'ResponseRate': {
        yAxisTitle: '% Responded < 15 Min',
        displayName: 'Response Rate',
        pointLabelFormat: '{value}%',
        propertyName: 'responseRate15',
        metricFormatKey: constants.formatKeys.percentageTwoDecimals,
        formatter: (val) => Math.round(val * 100)
      },
      'CloseRate': {
        yAxisTitle: 'Close Rate',
        displayName: 'Close Rate',
        pointLabelFormat: '{value}%',
        propertyName: 'bestMatchCloseRate',
        metricFormatKey: constants.formatKeys.percentageTwoDecimals,
        formatter: (val) => Math.round(val * 10000) / 100
      }
    }
  };

  public dealerBenchmarkColumns: IDefaultTableColumnConfig[] = [
    {
      show: true,
      header: '',
      columnDef: 'entity',
      metricFormatKey: constants.formatKeys.entityDisplayName, clickable: true
    },
    {
      show: false,
      print: true,
      header: 'Dealer Name',
      columnDef: 'displayName',
      metricFormatKey: constants.formatKeys.entityDisplayName
    },

    // Lead Volume
    {
      show: true,
      header: 'Total Leads',
      columnDef: 'leadVolume',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.localeString
    },

    // Unique Lead Volume
    {
      show: true,
      header: 'Total Unique Leads',
      columnDef: 'uniqueLeads',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.localeString
    },

    // Response Rate
    {
      show: true,
      header: 'Response Rate < 15 Min',
      columnDef: 'responseRate15',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals
    },

    // Average Response Time
    {
      show: true,
      header: 'Avg Response Time (48 hrs)',
      columnDef: 'averageResponseTime48Hour',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.minutesTimeString,
      printFormatKey: constants.formatKeys.roundToInteger
    },

    // Appointment Rate
    {
      show: true,
      header: 'Appointment Rate',
      columnDef: 'appointmentRate',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals
    },

    // Close Rate
    {
      show: true,
      header: 'Close Rate',
      columnDef: 'bestMatchCloseRate',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals
    },

    // 30 Day Close Rate
    {
      show: true,
      header: '30-Day Close Rate',
      columnDef: 'bestMatchCloseRate30',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa,
      comparisonFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa
    },

    // 60 Day Close Rate
    {
      show: true,
      header: '60-Day Close Rate',
      columnDef: 'bestMatchCloseRate60',
      hasComparisonMetrics: true,
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa,
      comparisonFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa
    },

    // 90 Day Close Rate
    {
      show: true,
      header: '90-Day Close Rate',
      columnDef: 'bestMatchCloseRate90',
      hasComparisonMetrics: true,
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa,
      comparisonFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa
    },
  ];

  public dealerBenchmarkLookbackColumns: IDefaultTableColumnConfig[] = [
    {
      show: true,
      header: '',
      columnDef: 'entity',
      metricFormatKey: constants.formatKeys.entityDisplayName, clickable: true
    },
    {
      show: false,
      print: true,
      header: 'Dealer Name',
      columnDef: 'displayName',
      metricFormatKey: constants.formatKeys.entityDisplayName
    },

    // Lead Volume
    {
      show: true,
      header: 'Total Leads',
      columnDef: 'leadVolume',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.localeString,
    },

    // Unique Lead Volume
    {
      show: true,
      header: 'Total Unique Leads',
      columnDef: 'uniqueLeads',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.localeString,
    },

    // Response Rate
    {
      show: true,
      header: 'Response Rate < 15 Min',
      columnDef: 'responseRate15',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals
    },

    // Average Response Time
    {
      show: true,
      header: 'Avg Response Time (48 hrs)',
      columnDef: 'averageResponseTime48Hour',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.minutesTimeString
    },

    // Appointment Rate
    {
      show: true,
      header: 'Appointment Rate',
      columnDef: 'appointmentRate',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals
    },

    // Close Rate
    {
      show: true,
      header: 'Close Rate',
      columnDef: 'bestMatchCloseRate',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals
    },

    // 30 Day Close Rate
    {
      show: true,
      header: '30-Day Close Rate',
      columnDef: 'bestMatchCloseRate30',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa,
      comparisonFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa
    },

    // 60 Day Close Rate
    {
      show: true,
      header: '60-Day Close Rate',
      columnDef: 'bestMatchCloseRate60',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa,
      comparisonFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa
    },

    // 90 Day Close Rate
    {
      show: true,
      header: '90-Day Close Rate',
      columnDef: 'bestMatchCloseRate90',
      hasComparisonMetrics: true,
      metricFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa,
      comparisonFormatKey: constants.formatKeys.percentageTwoDecimalsOrNa
    },
  ];
}
